import React, { useEffect, useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

function Sidebar() {
  const [activeLink, setActiveLink] = useState("");
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    const path = location.pathname.split("/").pop();
    setActiveLink(path);
  }, [location]);

  const isActive = (path) => {
    return activeLink === path ? "active-link" : "";
    //  return path.some((path) => location.pathname.startsWith(path)) ? "active-link" : "";
  };

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);
  
  
  return (
    <div>
      <div className="col-lg-3">
        <div className="dashboard_pages_list">
          {/* <Link
            to="/deposit"
            className={`dashboard_title ${isActive("deposit")}`}
          >
            <img
              src={require("../assests/icons/deposit-icon.png")}
              alt="Deposit"
            />
            <h3>Deposit</h3>
          </Link> */}
          <Link to="/assets" className={`dashboard_title `}>
            <img
              src={require("../assests/icons/deposit-icon.png")}
              alt="Assets"
            />
            <h3>{t("Assets")}</h3>
          </Link>

          <Link
            to="/security-withdraw"
            className={`dashboard_title ${isActive("withdrawaddress")}`}
          >
            <img
              src={require("../assests/icons/withdraw-icon.png")}
              alt="withdrawaddress"
            />
            <h3>{t("AddWithdrawAddress")}</h3>
          </Link>

          <Link
            to="/withdraw"
            className={`dashboard_title ${isActive("withdraw")}`}
          >
            <img
              src={require("../assests/icons/withdraw-icon.png")}
              alt="Withdraw"
            />
            <h3>{t("Withdraw")}</h3>
          </Link>
          {/* <Link
            to="/transferwallet"
            className={`dashboard_title ${isActive("transferwallet")}`}
          >
            <img src={require("../assests/transfer.webp")} alt="transferwallet" />
            <h3>Transfer</h3>
          </Link> */}
          {/* <Link to="/apibind" className={`dashboard_title ${isActive("apibind")}`}>
              <img src={require("../assests/icons/api-bind.png")} alt="API Bind" />
              <h3>API Bind</h3>
            </Link> */}

          {/* <Link
            to="/upgrade"
            className={`dashboard_title ${isActive("upgrade")}`}
          >
            <img src={require("../assests/upgrade.webp")} alt="API Bind" />
            <h3>Upgrade</h3>
          </Link> */}
          {/* <Link
            to="/bottradehistory"
            className={`dashboard_title ${isActive("bottradehistory")}`}
          >
            <img src={require("../assests/history.webp")} alt="API Bind" />
            <h3>Bot Trade</h3>
          </Link> */}
          {/* <Link
            to="/strategies"
            className={`dashboard_title ${isActive("strategies")}`}
          >
            <img
              src={require("../assests/startegy-icon.png")}
              alt="Strategies"
              className="nofil-new"
            />
            <h3>{t("Strategies")}</h3>
          </Link> */}
          {/* <Link to="/team" className={`dashboard_title ${isActive("team")}`}>
            <img src={require("../assests/icons/team-ico.png")} alt="team" />
            <h3>Your Team</h3>
          </Link>
          <Link
            to="/poolhistory"
            className={`dashboard_title ${isActive("poolhistory")}`}
          >
            <img
              src={require("../assests/pool-icon.png")}
              alt="Pool Progress"
              className="nofil-new-second"
            />
            <h3>Pool</h3>
          </Link> */}
          <Link
            to="/profile"
            className={`dashboard_title ${isActive("profile")}`}
          >
            <img
              src={require("../assests/icons/user-icon.png")}
              alt="Profile"
            />
            <h3>{t("Profile")}</h3>
          </Link>
          <Link
            to="/security"
            className={`dashboard_title ${isActive("security")}`}
          >
            <img
              src={require("../assests/icons/Security-icon.png")}
              alt="Security"
            />
            <h3>{t("Security")}</h3>
          </Link>

          <Link to="/faq" className={`dashboard_title ${isActive("faq")}`}>
            <img
              src={require("../assests/icons/question-icon.png")}
              alt="FAQs"
            />
            <h3>{t("FAQs")}</h3>
          </Link>

          {/* <Link
            to="/policy"
            className={`dashboard_title ${isActive("policy")}`}
          >
            <img
              src={require("../assests/icons/policy-icon.png")}
              alt="Policy"
            />
            <h3>Policy</h3>
          </Link> */}
          <Link
            to="/support"
            className={`dashboard_title ${isActive("support")}`}
          >
            <img src={require("../assests/support.webp")} alt="support" />
            <h3>{t("Support")}</h3>
          </Link>
          <Link
            to="/history"
            className={`dashboard_title ${isActive("history")}`}
          >
            <img src={require("../assests/history.webp")} alt="support" />
            <h3>{t("History")}</h3>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
